const prepareExpressionFunction = ({ functionName, paramsArray = [] }) => {
  const adjustedparamsArray = paramsArray.map(val => (isNaN(val[0]) ? val : `[${val}]`)).join(', ');
  return `${functionName}(${adjustedparamsArray})`;
};

export default prepareExpressionFunction;
